import { agreementNextAction, nextOpenAgreement } from './commercialCommitmentState';

export const customerWorkspaceTabs = [
  { id: 'SUMMARY', label: 'Summary' },
  { id: 'RELATIONSHIP', label: 'Relationship' },
  { id: 'REVENUE', label: 'Revenue' },
  { id: 'BILLING', label: 'Billing' },
  { id: 'HISTORY', label: 'History' },
];

export const getCustomerTabAction = (tab, commitments, upcomingRenewal) => {
  if (tab === 'REVENUE') {
    const renewalAgreement = upcomingRenewal && (commitments || []).find(commitment => (
      commitment.status !== 'CANCELLED' && commitment.renewalId === upcomingRenewal.id
    ));
    return renewalAgreement
      ? { id: 'OPEN_BILLING', label: 'Review agreement', agreementId: renewalAgreement.id }
      : { id: 'PLAN_AGREEMENT', label: 'Plan agreement' };
  }
  if (tab === 'BILLING') {
    const agreement = nextOpenAgreement(commitments);
    if (!agreement) {
      const existingRenewalAgreement = upcomingRenewal && (commitments || []).find(commitment => (
        commitment.status !== 'CANCELLED' && commitment.renewalId === upcomingRenewal.id
      ));
      return existingRenewalAgreement
        ? { id: 'PLAN_EXPANSION', label: 'Plan expansion' }
        : { id: 'PLAN_AGREEMENT', label: 'Plan agreement' };
    }
    const action = agreementNextAction(agreement);
    return action.disabled
      ? { id: action.id, label: action.label, agreementId: agreement.id, disabled: true }
      : { id: action.id, label: action.label, agreementId: agreement.id };
  }
  if (tab === 'HISTORY') return { id: 'ADD_NOTE', label: 'Add note' };
  return { id: 'LOG_CONTACT', label: 'Log client contact' };
};
